import clsx from "clsx";
import { forwardRef, type InputHTMLAttributes } from "react";

import styles from "./input.module.css";

type Props = InputHTMLAttributes<HTMLInputElement> & {
    /** input has invalid value - if set to `true` input turns red */
    hasError?: boolean;
};

/**
 * Input should be mostly used for text and numeric input
 *
 * > __Note__:
 * > this component isn't supposed to be used for date input
 */
const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { className, hasError, ...otherProps } = props;

    return (
        <input
            className={clsx(styles.input, { [styles.input_error]: hasError }, className)}
            ref={ref}
            {...otherProps}
        />
    );
});

Input.displayName = "Input";

export { Input };
export type { Props as InputProps };
